import React from "react";
import { useSelector } from "react-redux";
import AgentAccept from "./AgentAccept";
import AgentQuestion from "./AgentQuestion";

export default function Agent() {
  const agent_lvl = useSelector((state) => state.login.user?.agent_lvl);

  if (agent_lvl === -1) return <AgentQuestion />;

  return <AgentAccept />;
}
